import { render, staticRenderFns } from "./AddBranch.vue?vue&type=template&id=10b0574b&scoped=true"
import script from "./AddBranch.vue?vue&type=script&lang=js"
export * from "./AddBranch.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AddBranch.vue?vue&type=style&index=1&id=10b0574b&prod&lang=css"
import style2 from "./AddBranch.vue?vue&type=style&index=2&id=10b0574b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0574b",
  null
  
)

export default component.exports